// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b651d17e","513":"22967002","703":"2aed68ac","787":"2a76246b"}[chunkId] + ".chunk.js";
};